import React, { useRef, useEffect, useState, FunctionComponent } from 'react';
import { Tooltip, Typography, TypographyProps } from '@mui/material';
import { omit } from 'lodash';

interface OverflowTipProps extends TypographyProps {
  value: any;
}

const OverflowTip: FunctionComponent<OverflowTipProps> = (props) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [tooltipEnabled, setTooltipEnabled] = useState(false);

  useEffect(() => {
    const compareSize = () => {
      if (ref.current) {
        const compare = ref.current.scrollWidth > ref.current.clientWidth;

        setTooltipEnabled(compare);
      }
    };
    compareSize();
    window.addEventListener('resize', compareSize);
    return () => window.removeEventListener('resize', compareSize);
    // CLD-3040: re-measure on value change too, not just mount/resize.
  }, [props.value]);

  return (
    <Tooltip
      arrow
      title={props.value}
      disableHoverListener={!tooltipEnabled}
      placement="top"
      componentsProps={{
        popper: {
          modifiers: [
            {
              name: 'preventOverflow',
              options: { boundary: 'clippingParents', padding: 8 },
            },
            {
              name: 'flip',
              options: { fallbackPlacements: ['bottom', 'top'] },
            },
          ],
        },
        tooltip: {
          sx: {
            maxHeight: '40vh',
            overflowY: 'auto',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          },
        },
      }}
    >
      <Typography
        {...omit(props, 'value', 'sx')}
        noWrap
        ref={ref}
        variant={props.variant || 'body2'}
        sx={{ lineHeight: 'inherit', ...props.sx }}
      >
        {props.value}
      </Typography>
    </Tooltip>
  );
};

export default OverflowTip;
